import React, { useState, useEffect } from "react";
import * as constantMessages from "../../constants/constatntMessages";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCurrentAttendeesList,
  fetchExistingGuest,
} from "../../redux/actions/meetingActions/MeetingAction";
import Select from "react-select";
import { getEmployeeList } from "../../redux/actions/userAction/userAction";
import LoaderButton from "../Common/LoaderButton";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  createMinutes,
  setFinalMinuteData,
} from "../../redux/actions/minuteActions/MinuteAction";
import {
  checkEmptyString,
  cleanInput,
  getStringLengthAfterHTMLParse,
  encryptWithAES,
} from "../../helpers/commonHelpers";

import ReactQuill from "../../../node_modules/react-quill/lib/index";
import { checkDuplicateUser } from "../../redux/actions/userAction/userAction";
import RemoveAttendeesModalAction from "../Meeting/RemoveAttendeesModalNew";
import AttendeeDragDropNew from "../Meeting/AttendeeDragDropNew";

import SmallLoaderButton from "../Common/SmallLoaderButton";

const regularExpressionForAgendaTitle =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;
const AddMinuteModal = (props) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["header", "bold", "italic", "underline", "list", "bullet"];
  const regularExpression = /^[0-9a-zA-Z .(),/-]+$/;
  const regularExpressionName = /^[a-zA-Z .(),/-]+$/;
  const meetingData = useSelector((state) => state.meeting);
  const minuteDatas = useSelector((state) => state.minute);
  const employeeData = useSelector((state) => state.user);
  const minutesDetails = useSelector((state) => state.minute);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});

  const [selectedAttendeeOption, setSelectedAttendeeOption] = useState(null);

  const [selectedEmployeeOption, setSelectedEmployeeOption] = useState(null);
  const [description, setDescription] = useState("");

  const guestTypeOptions = [
    { value: "new", label: "Add New Guest" },
    { value: "existing", label: "Select from Existing" },
  ];
  const [addNewPeopleType, setAddNewPeopleType] = useState(""); // new state


  const [selectedExistingGuestOption, setSelectedExistingGuestOption] =
    useState(null);
  const [addNewSubOption, setAddNewSubOption] = useState("");

  const [addedUserError, setAddedUserError] = useState("");
  const [attendData, setAttendData] = useState([
    { id: "", name: "", email: "", profilePicture: "" },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [removeAttendeeData, setRemoveAttendeeData] = useState({});

  const [attendeeOptions, setAttendeeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [existingGuestOptions, setExistingGuestOptions] = useState([]);
  const [allGuestList, setAllGuestList] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    date: "",
    priority: "",
    attendyType: "fromCurrentMeeting",
    // responsibleUser: "",
    responsibleUser: [],
    isAction: false,
    name: "",
    email: "",
    designation: "",
    companyName: "",
    role: "",
    department: "",
  });
  const [minuteData, setMinuteData] = useState([]);

  useEffect(() => {
    if (
      minutesDetails?.finalMinutesData?.length !== 0 &&
      minuteData.length === 0
    ) {
      setMinuteData(minutesDetails.finalMinutesData);
    }
    setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
    setSelectedAttendeeOption([{ label: "*Name / Email Address", value: "" }]);
  }, []);

  useEffect(() => {
    if (formData?.isAction) {
      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          meetingData?.meetingDetails?._id,
          accessToken
        )
      );
    }
  }, [formData?.isAction]);

  useEffect(() => {
    if (minutesDetails.isSuccess) {
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
      setExistingGuestOptions({ label: "*Name / Email Address", value: "" });
      setFormData({
        ...formData,
        title: "",
        description: "",
        date: "",
        priority: "",
        attendyType: "fromCurrentMeeting",
        // responsibleUser: "",
        responsibleUser: [],
        isAction: false,
        name: "",
        email: "",
        companyName: "",
        designation: "",
        role: "",
        department: "",
      });
    }
  }, [minutesDetails.isSuccess]);

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        const response = await dispatch(
          fetchExistingGuest(userData.organizationId, accessToken)
        );
        const guests = response.data || [];
        setAllGuestList(guests);
      } catch (error) {
        console.error("Error fetching guests:", error);
      }
    };

    fetchGuests();
  }, []);

  useEffect(() => {
    const filteredGuests = allGuestList.filter((guest) => {
      return !attendData.some(
        (att) => att.email?.toLowerCase() === guest.email?.toLowerCase()
      );
    });

    const options = filteredGuests.map((guest) => ({
      value: guest._id,
      label: `${guest.name} / ${guest.email}`,
      profilePicture: guest.profilePicture,
      email: guest.email,
    }));

    setExistingGuestOptions(options);
  }, [allGuestList, attendData]);

  let attendeesData = meetingData.meetingDetails.attendees.map((attendee) => {
    return {
      id: attendee._id,
      status: "PENDING",
      profilePicture: attendee.profilePicture,
    };
  });


  useEffect(() => {
    if (meetingData?.currentAttendeesList?.length > 0) {
      const filtered = meetingData.currentAttendeesList.filter((attendee) => {
        return !attendData.some(
          (assigned) =>
            assigned.email?.toLowerCase() === attendee.email?.toLowerCase()
        );
      });

      const meetingAttendee = filtered.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.name} / ${attendee.email}`,
        name: "attendeeId",
        profilePicture: attendee.profilePicture,
      }));
      setAttendeeOptions(meetingAttendee);
    }
  }, [meetingData, attendData]);

  useEffect(() => {
    const filteredGuests = allGuestList.filter((guest) => {
      return !attendData.some(
        (att) => att.email?.toLowerCase() === guest.email?.toLowerCase()
      );
    });

    const options = filteredGuests.map((guest) => ({
      value: guest._id,
      label: `${guest.name} / ${guest.email}`,
      profilePicture: guest.profilePicture,
      email: guest.email,
    }));

    setExistingGuestOptions(options);
  }, [allGuestList, attendData]);

  useEffect(() => {
    if (employeeData?.employeeList?.length > 0) {
      const filtered = employeeData.employeeList.filter((emp) => {
        return !attendData.some(
          (att) => att.email?.toLowerCase() === emp.email?.toLowerCase()
        );
      });

      const employeeOpt = filtered.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.name} / ${attendee.empId}`,
        email: attendee.email,
        profilePicture: attendee.profilePicture,
        isEmployee: true,
      }));

      setEmployeeOptions(employeeOpt);
    }
  }, [employeeData, attendData]);

  const checkHandler = (e, uid) => {
    const { checked } = e.target;

    if (uid) {
      const modifiedMinutes = minutesDetails.finalMinutesData.map((obj) => {
        if (obj.uid === uid) {
          return { ...obj, isAction: checked };
        }
        return obj;
      });
      dispatch(setFinalMinuteData(modifiedMinutes));
    } else {
      setFormData({
        ...formData,
        isAction: !formData.isAction,
        date: "",
        priority: "",
        attendyType: "fromCurrentMeeting",
        // responsibleUser: "",
        responsibleUser: [],
        name: "",
        email: "",
        role: "",
        department: "",
      });
    }
    setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
    setSelectedAttendeeOption([{ label: "*Name / Email Address", value: "" }]);
    setExistingGuestOptions([{ label: "*Name / Email Address", value: "" }]);
  };

  const handleChange = (e, uid) => {
    setErrors({});
    const { name, value } = e.target;
    const updatedValue = name === "email" ? value.toLowerCase() : value;
    if (uid) {
      const modifiedMinutes = minutesDetails.finalMinutesData.map((obj) => {
        if (obj.uid === uid) {
          return { ...obj, [name]: updatedValue };
        }
        return obj;
      });
      dispatch(setFinalMinuteData(modifiedMinutes));
    } else {
      setFormData({
        ...formData,
        [name]: updatedValue,
      });
    }

    if (updatedValue === "fromEmployeeList") {
      setFormData((prev) => ({
        ...prev,
        // responsibleUser: "",
        responsibleUser: [],
      }));
      const payload = {
        organizationId: userData.organizationId,
      };
      dispatch(getEmployeeList(payload, accessToken));
      setExistingGuestOptions([{ label: "*Name / Email Address", value: "" }]);
      setSelectedAttendeeOption([{ label: "Name / Email Address", value: "" }]);
    }

    if (accessToken && updatedValue === "fromCurrentMeeting") {
      setFormData((prev) => ({
        ...prev,
        // responsibleUser: "",
        responsibleUser: [],
      }));

      setExistingGuestOptions([{ label: "*Name / Email Address", value: "" }]);
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          meetingData?.meetingDetails?._id,
          accessToken
        )
      );
    }

    if (updatedValue === "addNewPeople") {
      setFormData((prev) => ({
        ...prev,
        // responsibleUser: "",
        responsibleUser: [],
      }));
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
      setExistingGuestOptions([{ label: "*Name / Email Address", value: "" }]);
    }
    if (value === "addNewPeople") {
      setAddNewSubOption(""); //

      const getGuests = async () => {
        try {
          const response = await dispatch(
            fetchExistingGuest(userData.organizationId, accessToken)
          );

          const guestData = response.data.map((value) => {
            return {
              value: value._id,
              label: `${value.name}/${value.email}`,
            };
          });

          setExistingGuestOptions(guestData);
        } catch (error) {
          console.error("error", error);
        }
      };
      getGuests();
    }
    if (name === "attendyType" && value === "addNewPeople") {
      setAddNewPeopleType("new");
    }
  };

  const validateMinuteDescription = () => {
    const errors = {};

    if (!checkEmptyString(description?.trim())) {
      errors.description = constantMessages.descriptionRequired;
    }

    setErrors(errors);
  };

  const validateMinuteTitle = () => {
    const errors = {};
    if (!formData?.title?.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (formData.title.length < 5 || formData.title.length > 200) {
      errors.title = "Title must be between 5-200  characters";
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.htmlTagsNotAllowed;
    }

    setErrors(errors);
  };

  const dateFieldValidationCheck = (e) => {
    const errors = {};

    if (formData?.date?.trim() && formData.isAction) {
      const currentDate = new Date(meetingData?.meetingDetails?.date);
      const inputDate = new Date(formData.date);
      let differenceInTime = inputDate.getTime() - currentDate.getTime();
      let differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
      if (differenceInDays < 0) {
        errors.date = constantMessages.dateMoreThanMeetingDate;
      }
    } else if (!formData?.date?.trim()) {
      errors.date = constantMessages.dateRequired;
    }
    setErrors(errors);
  };

  const nameFieldValidationCheck = (e) => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = constantMessages.nameRequired;
    } else if (!regularExpressionName.test(formData.name)) {
      errors.name = constantMessages.invalidName;
    } else if (
      formData.name.trim().length < 2 ||
      formData.name.trim().length > 100
    ) {
      errors.name = constantMessages.nameLengthError;
    }

    setErrors(errors);
  };

  const emailFieldValidationCheck = (e) => {
    const errors = {};

    if (!formData.email.trim()) {
      errors.email = constantMessages.emailRequired;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = constantMessages.invalidEmail;
    }
    setErrors(errors);
  };

  const validateForm = (data) => {
    const abc = description.replace(/  +/g, " ");

    const errors = {};

    const isAddNewPeople = formData?.attendyType === "addNewPeople";
    const isAction = formData?.isAction === true;

    if (isAddNewPeople && addNewPeopleType === "existing") {
      // Must have selected existing guest
      if (formData.email === null) {
        errors.responsiblePerson = constantMessages.responsiblePersonRequired;
      }
    }
    // Title validation
    if (!formData?.title?.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (formData.title.length < 5 || formData.title.length > 200) {
      errors.title = "Title must be between 5-200 characters";
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.htmlTagsNotAllowed;
    }

    // Description validation
    if (!checkEmptyString(description?.trim())) {
      errors.description = constantMessages.descriptionRequired;
    }

    // Due date validation (if isAction)
    if (formData?.date?.trim() && isAction) {
      const currentDate = new Date(meetingData?.meetingDetails?.date);
      const inputDate = new Date(formData.date);
      let differenceInTime = inputDate.getTime() - currentDate.getTime();
      let differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
      if (differenceInDays < 0) {
        errors.date = constantMessages.dateMoreThanMeetingDate;
      }
    } else if (!formData?.date?.trim() && isAction) {
      errors.date = constantMessages.dateRequired;
    }

    // Priority validation
    if (!formData?.priority?.trim() && isAction) {
      errors.priority = constantMessages.priorityRequired;
    }

    // Designation (optional but validated if present)
    if (formData?.designation?.trim()) {
      if (!regularExpression.test(formData.designation)) {
        errors.designation = constantMessages.invalidDesignation;
      } else if (
        formData.designation.length < 2 ||
        formData.designation.length > 100
      ) {
        errors.designation = "Designation must be between 2-100 characters.";
      }
    }

    // Company name (optional but validated if present)
    if (formData?.companyName?.trim()) {
      if (!regularExpression.test(formData.companyName)) {
        errors.companyName = constantMessages.invalidCompanyName;
      } else if (
        formData.companyName.length < 2 ||
        formData.companyName.length > 50
      ) {
        errors.companyName = "Company name must be between 2-50 characters.";
      }
    }

    if (
      !attendData ||
      attendData.length === 0 ||
      (attendData.every(
        (item) =>
          (!item.id || item.id.trim() === "") &&
          (!item.email || item.email.trim() === "")
      ) &&
        isAction)
    ) {
      // alert("2");
      errors.responsiblePerson = constantMessages.responsiblePersonRequired;
    }

    return errors;
  };

  const formattedAssignedUsers = attendData
    .map((user) => ({
      _id: user.id && user.id.trim() !== "" ? user.id.trim() : undefined,
      name: user.name?.trim() || "",
      email: user.email?.trim() || "",
      profilePicture: user.profilePicture || "",
      isNewUser: user.isNewUser,
      designation: user.designation || "",
      role: user.role || "",
      department: user.department || "",
    }))
    .filter((user) => user.name && user.email);

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        const response = await dispatch(
          fetchExistingGuest(userData.organizationId, accessToken)
        );
        const guests = response.data || [];
        setAllGuestList(guests);
      } catch (error) {
        console.error("Error fetching guests:", error);
      }
    };

    fetchGuests();
  }, []);

  useEffect(() => {
    const filteredGuests = allGuestList.filter((guest) => {
      return !attendData.some(
        (att) => att.email?.toLowerCase() === guest.email?.toLowerCase()
      );
    });

    const options = filteredGuests.map((guest) => ({
      value: guest._id,
      label: `${guest.name} / ${guest.email}`,
      profilePicture: guest.profilePicture,
      email: guest.email,
    }));

    setExistingGuestOptions(options);
  }, [allGuestList, attendData]);

  
  useEffect(() => {
    if (employeeData?.employeeList?.length > 0) {
      const filtered = employeeData.employeeList.filter((emp) => {
        return !attendData.some(
          (att) => att.email?.toLowerCase() === emp.email?.toLowerCase()
        );
      });

      const employeeOpt = filtered.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.name} / ${attendee.empId}`,
        email: attendee.email,
        profilePicture: attendee.profilePicture,
        isEmployee: true,
      }));

      setEmployeeOptions(employeeOpt);
    }
  }, [employeeData, attendData]);

  const preventEnterKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleGuestChange = (e) => {
    setErrors({});
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedExistingGuestOption(e);
  };

  const onAddMinute = () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      let name, email, department, designation, role;
      const isAddNewPeople = formData?.attendyType === "addNewPeople";
      const isAction = formData?.isAction === true;

      if (isAddNewPeople) {
        if (addNewPeopleType === "new") {
          name = formData.name;
          email = formData.email;
          department = formData.department;
          designation = formData.designation;
          role = formData.role;
          // alert("In New");
        } else if (
          addNewPeopleType === "existing" &&
          selectedExistingGuestOption
        ) {
          const [guestName, guestEmail] =
            selectedExistingGuestOption?.label?.split("/");
          name = guestName.trim();
          email = guestEmail.trim();
          const assignedUserId = selectedExistingGuestOption?.value;
          if (
            assignedUserId &&
            !formattedAssignedUsers.find((u) => u._id === assignedUserId)
          ) {
            formattedAssignedUsers.push({
              _id: assignedUserId,
              name,
              email,
              profilePicture: "",
              isNewUser: false,
            });
          }
          setExistingGuestOptions((prev) =>
            prev.filter(
              (opt) => opt.value !== selectedExistingGuestOption.value
            )
          );
        }
      }

      const newMinuteData = {
        organizationId: userData?.organizationId,
        agendaId: props?.agenda?._id,
        meetingId: meetingData?.meetingDetails?._id?.toString(),
        attendees: attendeesData,
        description: encryptWithAES(description),
        title: cleanInput(formData?.title),
        dueDate: isAction && formData.date !== "" ? formData.date : undefined,
        priority:
          isAction && formData.priority !== "" ? formData.priority : undefined,
        assignedUserId: isAction ? formattedAssignedUsers : undefined,
        isAction: isAction || false,
        name: isAction && name ? name : undefined,
        email: isAction && email ? email : undefined,
        designation:
          formData.designation?.trim() !== ""
            ? formData.designation
            : undefined,
        companyName:
          formData.companyName?.trim() !== ""
            ? formData.companyName
            : undefined,
        department:
          formData.department?.trim() !== "" ? formData.department : undefined,
        role: formData.role?.trim() !== "" ? formData.role : undefined,
      };


      dispatch(
        createMinutes(
          {
            meetingId: meetingData?.meetingDetails?._id,
            minutes: [newMinuteData],
          },
          accessToken
        )
      );

      // Reset state
      setFormData({
        ...formData,
        date: "",
        priority: "",
        attendyType: "fromCurrentMeeting",
        responsibleUser: [],
        isAction: false,
        name: "",
        email: "",
        companyName: "",
        designation: "",
        department: "",
        role: "",
      });
      setDescription("");
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
      setSelectedExistingGuestOption([
        { label: "*Name / Email Address", value: "" },
      ]);
      setAttendData([{ id: "", name: "", email: "", profilePicture: "" }]);
    }
  };

  const handleAttendeeChange = (e) => {
    setErrors({});
    const { name, value } = e;

    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedAttendeeOption(e);
  };
  const handleEmployeeChange = (e) => {
    setErrors({});

    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedEmployeeOption(e);
  };

  const handleValue = (value) => {
    setErrors({});

    setDescription(value);
  };

  

  const assignAction = async () => {
    const attendeesToAdd = [];
    setAddedUserError("");
    setErrors({});

    // 1. From Guest Dropdown
    if (selectedAttendeeOption && selectedAttendeeOption.value) {
  
      const [namePart, emailPart] = selectedAttendeeOption.label.split(" / ");
      attendeesToAdd.push({
        id: selectedAttendeeOption.value,
        name: namePart.trim(),
        email: emailPart.trim(),
        isEmployee: selectedAttendeeOption.isEmployee,
        profilePicture: selectedAttendeeOption.profilePicture,
        isNewUser: false,
      });
     
      setAttendeeOptions((prev) =>
        prev.filter((opt) => opt.value !== selectedAttendeeOption.value)
      );
    }

    // 2. From Employee Dropdown
    if (selectedEmployeeOption && selectedEmployeeOption.value) {
   
      attendeesToAdd.push({
        id: selectedEmployeeOption.value,
        name: selectedEmployeeOption.label.split(" / ")[0].trim(),
        email: selectedEmployeeOption.email,
        isEmployee: selectedEmployeeOption.isEmployee,
        profilePicture: selectedEmployeeOption.profilePicture,
        isNewUser: false,
      });
      setEmployeeOptions((prev) =>
        prev.filter((opt) => opt.value !== selectedEmployeeOption.value)
      );
    }

    if (formData.attendyType === "addNewPeople") {


      if (addNewPeopleType === "existing" && selectedExistingGuestOption) {
        const [guestName, guestEmail] =
          selectedExistingGuestOption.label.split("/");
        attendeesToAdd.push({
          id: selectedExistingGuestOption.value,
          name: guestName.trim(),
          email: guestEmail.trim(),
          isEmployee: false,
          isNewUser: false,
        });
        setExistingGuestOptions((prev) =>
          prev.filter((opt) => opt.value !== selectedExistingGuestOption.value)
        );
      }
      // New guest
      else if (addNewPeopleType === "new" && formData.name && formData.email) {
        // alert("CAlled new guest");
        const duplicateInToAdd = attendeesToAdd.find(
          (u) => u.email.toLowerCase() === formData.email.toLowerCase()
        );
        if (duplicateInToAdd) {
          setErrors({ duplicateAttendee: constantMessages.duplicateAttendee });
          return;
        }

        const duplicateInExisting = attendData?.find(
          (att) => att.email?.toLowerCase() === formData.email.toLowerCase()
        );
        if (duplicateInExisting) {
          setAddedUserError(constantMessages.attendeeExist);
          setTimeout(() => setAddedUserError(""), 3000);
          return;
        }

        const payload = {
          organizationId: userData.organizationId,
          email: formData.email,
        };
        const response = await dispatch(
          checkDuplicateUser(payload, accessToken)
        );
        if (response?.data?.isDuplicateUser === true) {
          return;
        }

        try {
          // alert("In Try");
          const payload = {
            organizationId: userData.organizationId,
            email: formData.email,
          };

          attendeesToAdd.push({
            name: formData.name,
            email: formData.email,
            companyName: formData.companyName || "",
            designation: formData.designation || "",
            role: formData.role || "",
            department: formData.department || "",
            isNewUser: true,
          });
          setFormData((prev) => ({
            ...prev,
            name: "",
            email: "",
            designation: "",
            companyName: "",
            department: "",
            role: "",
          }));
        } catch (error) {
          console.error("Error checking for duplicate user:", error);
          setAddedUserError("Error checking user. Please try again.");
          setTimeout(() => setAddedUserError(""), 3000);
          return;
        }
      }
    }

    if (attendeesToAdd.length === 0 && addNewPeopleType !== "new") {
      const newErrors = { ...errors };
      // alert("3");
      newErrors.responsiblePerson = constantMessages.responsiblePersonRequired;
      setErrors(newErrors);
      setTimeout(() => setErrors(""), 3000);
      return;
    }
    if (attendeesToAdd.length === 0 && addNewPeopleType === "new") {
      const newErrors = { ...errors };
      // newErrors.responsiblePerson = constantMessages.responsiblePersonRequired;
      newErrors.name = constantMessages.nameRequired;
      newErrors.email = constantMessages.emailRequired;
      setErrors(newErrors);
      setTimeout(() => setErrors(""), 3000);
      return;
    }


    if (attendeesToAdd.length === 0) return;

    setAttendData((prevAttendData) => {
      const existing = prevAttendData || [];

      const normalizedExisting = existing.map(({ _id, ...rest }) => ({
        id: _id || rest.id,
        ...rest,
      }));

      const normalizedToAdd = attendeesToAdd.map(({ _id, ...rest }) => ({
        id: _id || rest.id,
        ...rest,
      }));

      const validToAdd = normalizedToAdd.filter(
        (att) => att.name?.trim() && att.email?.trim()
      );

      const uniqueAttendees = [
        ...normalizedExisting,
        ...validToAdd.filter(
          (newOne) =>
            !normalizedExisting.some(
              (existingOne) =>
                existingOne.email?.toLowerCase() === newOne.email?.toLowerCase()
            )
        ),
      ];

      if (uniqueAttendees.length === existing.length) {
        setAddedUserError(constantMessages.attendeeExist);
        setTimeout(() => setAddedUserError(""), 3000);
        return prevAttendData;
      }

      return uniqueAttendees;
    });

    setSelectedAttendeeOption(null);
    setSelectedEmployeeOption(null);
    setSelectedExistingGuestOption(null);
  };

  const removeAttendee = (e) => {
    const filteredAttendees = attendData?.filter(
      (item) => item.email !== removeAttendeeData?.email
    );

    setAttendData(
      filteredAttendees.map((attendee) => ({
        id: attendee.id,
        name: attendee.name,
        email: attendee.email,
        profilePicture: attendee.profilePicture,
        isNewUser: attendee.isNewUser,
      }))
    );

    setIsModalOpen(false);
    setFormData({
      ...formData,
      responsibleUser: [],
    });
  };

  const updatedAttendeesData = (attendees) => {
    setAttendData(props?.actionData?.assignedUserDetails);
  };
const resetModal = () => {
    setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
    setSelectedAttendeeOption([{ label: "*Name / Email Address", value: "" }]);

    setFormData({
      title: "",
      date: "",
      priority: "",
      attendyType: "fromCurrentMeeting",
      responsibleUser: "",
      isAction: false,
      name: "",
      email: "",
      companyName: "",
      designation: "",
      role: "",
      department: "",
    });
    setDescription("");
    setErrors({});
    setAttendData([{ id: "", name: "", email: "", profilePicture: "" }]);
  };
  const closeModal = () => {
    setErrors({});
    props.setIsAddMinuteModal(false);
    setFormData({
      title: "",
      date: "",
      priority: "",
      attendyType: "fromCurrentMeeting",
      // responsiblePersonId: "",
      responsiblePersonId: [],
      isAction: false,
      name: "",
      email: "",
      companyName: "",
      designation: "",
      role: "",
      department: "",
    });

    setAttendData([{ id: "", name: "", email: "", profilePicture: "" }]);
    setDescription("");
  };

  return (
    <>
      <Modal
        size="lg"
        show={props.isAddMinuteModal}
        onHide={(e) => props.setIsAddMinuteModal(false)}
        backdrop="static"
      >
        <div className="modal-header attendees-modal">
          <div>
            <h4 className="modal-title">
              Add Minute{" "}
              {props?.agendaDetails?.filter(
                (agenda) => agenda?._id === props?.agenda?._id
              )[0]?.minutesDetail?.length + 1}
            </h4>
          </div>
          <div className="d-flex gap-4 action-right-option">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(e) => closeModal()}
            ></button>
          </div>
        </div>

        <Modal.Body className="attendees-popup modal-margin">
          <div className="open-div">
            <form className="addminutesboxfrom">
              <div
                className={
                  props.isMinuteShow && props.index === props.currentIndex
                    ? "minutes-box no-border show"
                    : !props.isMinuteShow && props.index === props.currentIndex
                      ? "minutes-box no-border"
                      : "minutes-box no-border"
                }
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        Minutes Title <span className="star-mark">*</span>
                      </label>
                    </div>
                    <div className="col-md-12">
                      <input
                        type="text"
                        placeholder="Enter minutes title"
                        name="title"
                        value={formData.title}
                        autoComplete="off"
                        onBlur={validateMinuteTitle}
                        onChange={handleChange}
                      />
                      {errors.title ? (
                        <span className="error-message">{errors.title}</span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        Description <span className="star-mark">*</span>
                      </label>
                    </div>
                    <div className="col-md-82">
                      <ReactQuill
                        className="description-box"
                        theme="snow"
                        placeholder="Please add description"
                        onChange={handleValue}
                        value={description}
                        modules={modules}
                        formats={formats}
                        style={{ background: "white" }} // Adjust height here
                        onBlur={validateMinuteDescription}
                        className="custom-quill-editor"
                      />
                      {description ? (
                        <p className="success-message">
                          {getStringLengthAfterHTMLParse(description)}{" "}
                          Characters
                        </p>
                      ) : null}

                      {errors.description ? (
                        <span className="error-message">
                          {errors.description}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="add-action">
                  {formData.isAction ? (
                    <>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="form-group">
                            <div className="position-relative">
                              <label className="pb-2 input-date">
                                {" "}
                                Due Date <span className="star-mark">*</span>
                              </label>

                              <div
                                className="relative"
                                onClick={() =>
                                  document
                                    .getElementById("dateInput")
                                    .showPicker()
                                }
                              >
                                <input
                                  type="date"
                                  name="date"
                                  id="dateInput"
                                  value={formData.date}
                                  onChange={handleChange}
                                  onBlur={dateFieldValidationCheck}
                                />
                              </div>
                            </div>
                            {errors.date && (
                              <span className="error-message">
                                {errors.date}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="form-group">
                            <div className="position-relative">
                              <label className="pb-2 input-date">
                                Priority <span className="star-mark">*</span>
                              </label>
                              <div>
                                <select
                                  name="priority"
                                  id="priority"
                                  onChange={handleChange}
                                >
                                  {minuteData.priority &&
                                  minuteData?.isAction === true ? (
                                    <option value={minuteData.priority}>
                                      {minuteData.priority
                                        .charAt(0)
                                        .toUpperCase() +
                                        minuteData.priority
                                          .slice(1)
                                          .toLowerCase()}
                                    </option>
                                  ) : (
                                    <option value="">Select Priority</option>
                                  )}

                                  <option value="HIGH">High</option>
                                  <option value="NORMAL">Normal</option>
                                  <option value="LOW">Low</option>
                                </select>
                              </div>
                            </div>
                            {errors.priority ? (
                              <span className="error-message">
                                {errors.priority}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="form-group pb-3 border-bottom">
                        <label className="pb-2">
                          Select Responsible Persons{" "}
                          <span className="star-mark">*</span>
                        </label>
                        <RemoveAttendeesModalAction
                          isModalOpen={isModalOpen}
                          setIsModalOpen={setIsModalOpen}
                          attendee={removeAttendeeData}
                          meetingData={meetingData}
                          allowRemove={true}
                          message="Are you sure want to remove this attendee?"
                          handleSubmit={() =>
                            removeAttendee(
                              props?.actionData?.assignedUserDetails
                            )
                          }
                        />
                        <AttendeeDragDropNew
                          attendees={attendData}
                          updatedAttendeesData={updatedAttendeesData}
                          setIsModalOpen={setIsModalOpen}
                          setRemoveAttendeeData={setRemoveAttendeeData}
                          allowRemove={true}
                        />
                        <div className="w-100 mt-2">
                          <div className="form-check-inline">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="attendyType"
                                value="fromCurrentMeeting"
                                id="flexRadioDefault1"
                                onChange={handleChange}
                                checked={
                                  formData.attendyType === "fromCurrentMeeting"
                                }
                              />
                              <label
                                className="form-check-label"
                                for="flexRadioDefault1"
                                id="flexRadioDefault1"
                              >
                                Select From Current Meetings
                              </label>
                            </div>
                          </div>

                          <div className="form-check-inline">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="attendyType"
                                value="fromEmployeeList"
                                id="flexRadioDefault2"
                                onChange={handleChange}
                                checked={
                                  formData.attendyType === "fromEmployeeList"
                                }
                              />
                              <label
                                className="form-check-label"
                                for="flexRadioDefault2"
                                id="flexRadioDefault2"
                              >
                                Select From Employees
                              </label>
                            </div>
                          </div>

                          <div className="form-check-inline">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input  z-index-high"
                                type="radio"
                                name="attendyType"
                                value="addNewPeople"
                                id="flexRadioDefault3"
                                checked={
                                  formData.attendyType === "addNewPeople"
                                }
                                onChange={handleChange}
                              />
                              <label
                                className="form-check-label"
                                for="flexRadioDefault3"
                                id="flexRadioDefault3"
                              >
                                Add Guest
                              </label>
                            </div>
                          </div>
                        </div>

                        {formData.attendyType === "fromCurrentMeeting" ? (
                          <Select
                            className="fltr-opt"
                            placeholder="Name / Email Address"
                            name="responsibleUser"
                            options={attendeeOptions}
                            onChange={handleAttendeeChange}
                            value={selectedAttendeeOption}
                          />
                        ) : formData.attendyType === "fromEmployeeList" ? (
                          <Select
                            className="fltr-opt"
                            placeholder="Name / Employee ID"
                            name="responsibleUser"
                            options={employeeOptions}
                            value={selectedEmployeeOption}
                            onChange={handleEmployeeChange}
                          />
                        ) : formData.attendyType === "addNewPeople" ? (
                          <div className="mt-2">
                            <label className="">Select Guest Type</label>
                            <Select
                              className="fltr-opt mt-0"
                              name="addNewPeopleType"
                              placeholder="Select Guest Type"
                              options={guestTypeOptions}
                              onChange={(selectedOption) =>
                                setAddNewPeopleType(selectedOption.value)
                              }
                              value={guestTypeOptions.find(
                                (opt) => opt.value === addNewPeopleType
                              )}
                            />

                            {addNewPeopleType === "new" ? (
                              <div className="mt-3">
                                <label className="mb-1">Add New Guest</label>
                                <div className="row">
                                  <div className="col-xl-6 col-md-6">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="*Name"
                                      name="name"
                                      onKeyDown={preventEnterKey}
                                      value={formData.name}
                                      onChange={handleChange}
                                      onBlur={nameFieldValidationCheck}
                                    />
                                    {errors.name && (
                                      <span className="error-message">
                                        {errors.name}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-xl-6 col-md-6">
                                    <input
                                      type="text"
                                      placeholder="*Email"
                                      autoComplete="off"
                                      name="email"
                                      value={formData.email}
                                      onKeyDown={preventEnterKey}
                                      onBlur={emailFieldValidationCheck}
                                      onChange={handleChange}
                                      className="resp-mt-1"
                                    />
                                    {errors.email && (
                                      <span className="error-message">
                                        {errors.email}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Designation"
                                      name="designation"
                                      onKeyDown={preventEnterKey}
                                      value={formData.designation}
                                      onChange={handleChange}
                                    />
                                    {errors.designation && (
                                      <span className="error-message">
                                        {errors.designation}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Company Name"
                                      name="companyName"
                                      onKeyDown={preventEnterKey}
                                      value={formData.companyName}
                                      onChange={handleChange}
                                    />
                                    {errors.companyName && (
                                      <span className="error-message">
                                        {errors.companyName}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Role"
                                      name="role"
                                      onKeyDown={preventEnterKey}
                                      value={formData.role}
                                      onChange={handleChange}
                                    />
                                    {errors.role && (
                                      <span className="error-message">
                                        {errors.role}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Department"
                                      name="department"
                                      onKeyDown={preventEnterKey}
                                      value={formData.department}
                                      onChange={handleChange}
                                    />
                                    {errors.department && (
                                      <span className="error-message">
                                        {errors.department}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : addNewPeopleType === "existing" ? (
                              <>
                                <div className="mt-3">
                                  <label className="mb-1">
                                    Select Existing
                                  </label>
                                  <Select
                                    className="fltr-opt"
                                    placeholder="*Name / Email Address"
                                    name="attendeeId"
                                    // options={existingGuestOptions}
                                    options={existingGuestOptions.filter(
  (opt) =>
    !attendData.some(
      (att) => att.id?.toString() === opt.value?.toString()
    )
)}

                                    onChange={handleGuestChange}
                                    value={selectedExistingGuestOption}
                                  />
                                </div>
                              </>
                            ) : null}
                          </div>
                        ) : null}
                        {errors.responsiblePerson && (
                          <span className="error-message">
                            {errors.responsiblePerson}
                          </span>
                        )}
                      </div>
                      <button
                        type="button"
                        className="btn add-btn Mom-btn d-flex align-items-center justify-content-center "
                        onClick={assignAction}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="#fff"
                          className="bi bi-plus-circle pointer me-2"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                        </svg>
                        <p> Add </p>
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="d-flex gap-4 action-right-option">
              <div className="form-group">
                <div className=" mt-1 mb-1 d-flex justify-content-between align-items-center ">
                  <div className="form-check ">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      name="isAction"
                      onChange={checkHandler}
                      checked={formData.isAction}
                    />
                    <label
                      className="form-check-label add-action-bold"
                      id="flexCheckDefault"
                      for="flexCheckDefault"
                      style={{ fontWeight: "600" }}
                    >
                      Add Action
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2 action-right-option">
              <Button
                variant=""
                onClick={resetModal}
                className="add-btn Mom-btn"
                type="button"
              >
                <p> Reset</p>
              </Button>

              {!minuteDatas.loading ? (
                <Button
                  className="create-meeting-button Mom-btn"
                  variant=""
                  onClick={onAddMinute}
                >
                  <p> Submit</p>
                </Button>
              ) : (
                <div className="meeting-page " style={{ textAlign: "center" }}>
                  <SmallLoaderButton />
                </div>
              )}
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddMinuteModal;
